export const CREDITS_LEARN_MORE_URL = 'https://support.postermywall.com/hc/en-us/articles/42437980646285-How-much-does-PosterMyWall-AI-cost';
export const CREDITS_DROPDOWN_HOVER_CLOSE_DELAY_MS = 300;

export const CREDITS_MODAL_PANEL_ID = 'credits-modal-panel';
// MoreOptionsPanel defaults className to '', so the padding Dropdown normally supplies has to be passed explicitly.
export const MODAL_PANEL_PADDING_CLASS = 'spacing-p-l-4 spacing-p-r-4 spacing-p-b-4 spacing-p-t-3';
export const MODAL_TEXT_CLASSES = 'ct-neutral-primary';
// The tooltip sits on a dark surface, so its text needs the on-dark colour.
export const TOOLTIP_TEXT_CLASSES = 'ct-neutral-primary-on-dark';
